import React from 'react';
import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';

// Shared page-root wrapper enforcing the Inventory padding standard
// (px:{xs:2,sm:3,md:4}, pt:2, pb:3). Optional `sx` merges on top (caller wins).
const PageContainer: React.FC<{ children: React.ReactNode; sx?: SxProps<Theme> }> = ({ children, sx }) => (
    <Box sx={[{ px: { xs: 2, sm: 3, md: 4 }, pt: 2, pb: 3 }, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}>
        {children}
    </Box>
);

export default PageContainer;
